class FeaturedProductsTabs extends HTMLElement {
  tabButtons = [];
  tabContent = [];

  connectedCallback() {
    // Find all tab buttons within this component
    this.tabButtons = this.querySelectorAll('button[type="button"][role="tab"]');

    // Find all swiper elements within this component
    this.tabContent = this.querySelectorAll('[data-tab]');

    // Add click event listeners to tab buttons
    this.tabButtons.forEach((button) => {
      button.addEventListener('click', this.handleTabClick);
    });
  }

  disconnectedCallback() {
    this.tabButtons.forEach((button) => {
      button.removeEventListener('click', this.handleTabClick);
    });
  }

  handleTabClick = (event) => {
    const clickedButton = event.target;
    const buttonId = clickedButton.getAttribute('aria-controls');

    // Update all tab buttons - set clicked one to selected, others to not selected
    this.tabButtons.forEach((button) => {
      const isSelected = button === clickedButton;
      button.setAttribute('aria-selected', isSelected.toString());
    });

    // Show the corresponding swiper element and hide others
    this.tabContent.forEach((tab) => {
      const swiperDataAttribute = tab.getAttribute('id');
      const shouldShow = swiperDataAttribute === buttonId;
      tab.setAttribute('aria-hidden', (!shouldShow).toString());
    });
  };
}

// Register the custom element
customElements.define('featured-products', FeaturedProductsTabs);
